import { MutationTree } from 'vuex'
import { ContentState, ContentItem, ContentError, Consent } from './types'
import langMap from 'langmap'

export const mutations: MutationTree<ContentState> = {
  UPDATE_LANG (state, payload: string) {
    state.selectedLanguage = payload
  },
  UPDATE_COUNTRY (state, payload: string) {
    state.country = payload.toUpperCase()
  },
  UPDATE_FORCED_COUNTRY (state, payload: string) {
    state.forcedCountry = payload.toUpperCase()
  },
  NEED_COUNTRY_SELECTION (state, payload: boolean) {
    state.needCountrySelection = payload
  },
  SET_CONTENT (state, payload: { lang: string; content: ContentItem }) {
    if (typeof state.contents[payload.lang] === 'undefined') {
      const langContent = {} as { [key: string]: ContentItem}
      langContent[payload.lang] = payload.content
      state.contents = {
        ...state.contents,
        ...langContent
      }
      state.languages.push({ key: payload.lang, value: langMap[payload.lang].nativeName })
    } else {
      state.contents[payload.lang] = {
        ...state.contents[payload.lang],
        ...payload.content
      }
    }
  },
  SET_ERROR (state, payload: ContentError) {
    state.errors = {
      ...state.errors,
      ...payload
    }
  },
  INCREMENT_ID_COUNTER (state): void {
    state.idCounter++
  },
  SET_LOADED (state, payload: boolean): void {
    state.loaded = payload
  },
  SET_IFRAME_MODE (state, payload: boolean) {
    state.iframe = payload
  },
  SET_HIDE_GSC (state, payload: boolean) {
    state.hideGsc = payload
  },
  SET_CONSENT (state, payload: Consent): void {
    state.consent = payload
  }
}
